export { default as AuthenticationStorage } from './services/authentication-token'
export { AuthenticationTokenService } from './services/authentication-token'
export { identityPaths, setIdentityHomePath, getIdentityHomePath, useIdentityPaths } from './paths'
export const passwordStrengthRequirement = 80
